export const STUDENT_ONBOARDING_ROUTE = '/student/onboarding';

export const INTERNAL_FORMATION_PROGRAM_ID = 'wSKFKPVA4ZhngwONYquQ';

export const INTERNAL_FORMATION_PROGRAM_FALLBACK_NAME = 'Formación Interna';

export const INTERNAL_FORMATION_CHURCH = {
  churchName: 'Oasis de Amor',
  pastorName: 'Moisés Ferrer',
  pastorPhone: '8099402441',
} as const;
